var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-scroller pa-5"},[_c('sop-purpose',{staticClass:"mb-10"}),_c('sop-glossary',{staticClass:"mb-10"}),_c('sop-block-list',{staticClass:"mb-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }